// extracted by mini-css-extract-plugin
export default {"wrapper":"ReagentGroupsContent_wrapper__Pj53A"};